// extracted by mini-css-extract-plugin
module.exports = {"transition":"RasmusShowUser_transition_2wAmn","headline":"RasmusShowUser_headline_1qQDu","content":"RasmusShowUser_content_1aX3n"};